export const language: any ={
    OkLogout: "예",
    CloseLogout: "아니요",
    OkLeave: "탈퇴",
    CloseLeave: "취소",
    LabelPolicy: "개인정보 처리방침",
    AppName: "Hey! Cooker",
    OnOffNotification: "알림 On/Off",
    LabelReceiveNotificationSuggestion: "요리추천 알림 받기",
    LabelReceiveNotifyBreakfast: "매일 아침 식사 추천 받기",
    LabelReceiveNotifyLunch: "매일 점심 식사 추천 받기",
    LabelReceiveNotifyDinner: "매일 저녁 식사 추천 받기",
    notification_history: "알림이력",
    readAll: "전체 읽은",
    no_notification: "알림이력이 없습니다",
    labelDisplayName: "표시명 입력",
    placeholderDisplayName: "최대 20자, 최소 4자 입력해 주세요",
    changeDisplayName: "표시명 변경",
}

